import * as React from "react";
import { Box, Divider, Container, Typography, useScrollTrigger, Fade, Fab, Paper, useTheme } from "@mui/material";
import { KeyboardArrowUp } from "@mui/icons-material";
import Portfolio from "./Portfolio";
import Skills from "./Skills";
import Footer from "../components/Footer";

function ScrollTop(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector("#heroImage");
    if (anchor) {
      anchor.scrollIntoView();
    }
  };

  return (
    <Fade in={trigger}>
      <Box onClick={handleClick} role="presentation" sx={{ position: "fixed", bottom: 16, right: 16 }}>
        {children}
      </Box>
    </Fade>
  );
}

export default function Home(props) {
  const theme = useTheme();

  return (
    <>
      {/* sx={{ mt: { xs: 8, sm: 10, md: 12, lg: 14, xl: 16 } }} */}
      <div className="containerImgHero">
        <div id="heroImage" className="kenburns-top"></div>
      </div>
      <Box display="flex" alignItems="center" justifyContent="center" sx={{ minHeight: "100vh" }}>
        <Container maxWidth="lg" className="text-focus-in " sx={{ mt: { xs: 12, sm: 0 }, mb: { xs: 10, sm: 0 } }}>
          <Paper sx={{ p: 3, background: theme.palette.paperTransparent.main }} variant="outlined">
            <Typography variant="h3" component="p">
              Hi,
            </Typography>
            <Typography variant="h4" component="p">
              I'm Gustavo
            </Typography>

            <Typography color="primary" variant="h4" component="p" fontWeight="bold">
              Full Stack Web Developer
            </Typography>

            <br />

            <Typography variant="h4" component="p" id="descriptionHeroImage">
              front-end, back-end, ux/ui
            </Typography>
          </Paper>
        </Container>
      </Box>

      <Portfolio />

      <Container disableGutters maxWidth="lg">
        <Divider />
      </Container>

      <Skills />

      <ScrollTop {...props}>
        <Fab size="small" aria-label="scroll back to top" color="secondary" className="jello-horizontal">
          <KeyboardArrowUp color="toggleDarkMode" />
        </Fab>
      </ScrollTop>

      <Footer />
    </>
  );
}
